import styled from 'styled-components';
import { device } from '../../styles/devices';
import type { ThemeProps } from '../../types';
import { SYS_SIZE_FIXED_125 } from '@oneaudi/unified-web-common';

interface ThemeWithColorProps {
  theme: ThemeProps;
  color: string;
}

export const ButtonWrapper = styled.div<{
  isVisible: boolean;
  color: string;
  isNew: boolean;
  isT3: boolean;
}>`
  display: inline-block;
  visibility: ${({ isVisible }) => (!isVisible ? 'hidden' : 'visible')};
  margin-top: ${({ isNew }) => (!isNew ? '20px' : '32px')};
  padding-bottom: ${({ isNew, isT3 }) => (isT3 && isNew ? '0px' : '32px')};

  @media ${device.tablet} {
    padding-bottom: ${({ isNew, isT3 }) => (isT3 || !isNew ? '0px' : '32px')};
  }

  button {
    display: ${({ isVisible }) => (!isVisible ? 'none' : 'inline-block')};
    visibility: hidden;
    position: relative;
    padding-left: 0;
    margin-left: 0;
    z-index: 1;
    color: ${({ color }) => `${color} !important`};

    &:hover {
      color: ${({ color, theme }: ThemeWithColorProps) =>
        color === '#ffffff'
          ? `${theme.sys.color.surface.neutral[400]} !important`
          : `${theme.sys.color.surface.neutral[200]} !important`};
    }
  }

  span {
    display: flex;
    justify-content: space-between;
  }

  #vendorIntegrations__impel {
    background-color: transparent !important;
  }
`;

export const IconWrapper = styled.div<{
  color: string;
}>`
  svg {
    margin-right: 1em;
    fill: none;

    path {
      transition-duration: 250ms;
    }

    path:nth-child(4) {
      fill: ${({ color }) => color};
      ${ButtonWrapper}:hover & {
        transition-duration: 250ms;
        fill: ${({ color, theme }: ThemeWithColorProps) =>
          color === '#ffffff'
            ? theme.sys.color.surface.neutral[400]
            : theme.sys.color.surface.neutral[200]};
      }
    }

    path:nth-child(5) {
      stroke: ${({ color }) => color};
      ${ButtonWrapper}:hover & {
        transition-duration: 250ms;
        stroke: ${({ color, theme }: ThemeWithColorProps) =>
          color === '#ffffff'
            ? theme.sys.color.surface.neutral[400]
            : theme.sys.color.surface.neutral[200]};
      }
    }
  }
`;

export const ForwardIconWrapper = styled.div`
  padding-top: ${SYS_SIZE_FIXED_125};
`;
